// extracted by mini-css-extract-plugin
export default {"products":"yv-z","card":"zv-z","oosMessaging":"Av-z"};